import styles from './home.module.css'
import image from '../../images/homePage.png'
import Feature from "../../components/homepageComponents/feature/feature";
import Deals from "../../components/homepageComponents/deals/deals";
import {UseMenu} from "../../context/menuItemsContext";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";

const svgFile = {
	'smile': {__html: '<svg xmlns="http://www.w3.org/2000/svg" style="color: #c2004e; background-color: rgba(255,0,107,0.06)" fill="currentColor" className="bi bi-emoji-smile" viewBox="0 0 16 16">       <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>       <path        d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm4 0c0 .828-.448 1.5-1 1.5s-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5z"/>      </svg>'},
	'badge': {__html: '<svg xmlns="http://www.w3.org/2000/svg" style="color: #008523; background-color: rgba(0,255,61,0.27)" fill="currentColor" class="bi bi-patch-check" viewBox="0 0 16 16">   <path fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>   <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/> </svg>'},
	'discount': {__html: '<svg xmlns="http://www.w3.org/2000/svg" style="color: #00656c; background-color: rgba(106,255,248,0.21)" fill="currentColor" class="bi bi-percent" viewBox="0 0 16 16">   <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/> </svg>'},
	'local': {__html: '<svg xmlns="http://www.w3.org/2000/svg" style="color: #d55200; background-color: rgba(208,113,53,0.24)" fill="currentColor" class="bi bi-shop" viewBox="0 0 16 16">   <path d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z"/> </svg>'},
}


const Home = (props) =>
{
	let flag = 0;
	const [{getItem}] = UseMenu()
	const [getDeals, setDeals] = useState()
	useEffect(() =>
	{
		setDeals(getItem)
	}, [getItem])


	return (
		<>
			<div className={styles.container}>
				<div className={styles.info}>

					<h1 className={styles.heading}>
						<span className={styles.brandName}>Shaurashtra</span> <br/>Ice-Cream
					</h1>
					<div className={styles.tagLine}>
						Celebrate your sweet moments with our sweet.
					</div>
					<br/>
					<p className={styles.description}>
						We make the best ice-cream in the town. Our ice-cream is
						so delicious and affordable in prices. Place your order now
						to get your ice-cream.
					</p>
					<div className={styles.buttons}>
						<Link to="/menu">
							<button className={styles.primary}>
								Explore &nbsp;
								<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"
								     className="bi bi-arrow-right" viewBox="0 0 16 16">
									<path fillRule="evenodd"
									      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
								</svg>
							</button>
						</Link>
						<Link to="/contact">
							<button className={styles.secondary}>Contact us</button>
						</Link>
					</div>
				</div>
				<div className={styles.imageStyle}>
					<img className={styles.image} src={image} alt=""/>
				</div>
			</div>


			<h1 className={styles.pHeading}>Why Shaurashtra Ice-Cream</h1>
			<div className={styles.feature}>
				<Feature icone={svgFile.smile}
				         content="Our customers always come first. Make it right, make it memorable. Smile"
				         heading="Happy Customer"/>
				<Feature icone={svgFile.badge}
				         content="Best Quality Matters a lot. we know how precious your life is. You can trust us"
				         heading="Best Quality"/>
				<Feature icone={svgFile.discount}
				         content="Your favorite products made affordable for you Its time to Save More"
				         heading="Hello, Discounts!"/>
				<Feature icone={svgFile.local}
				         content="Put Your Money Where Your Heart Is. Always at your service! Shop Local"
				         heading="Your Local Shop"/>
			</div>

			<h1 className={styles.pHeading}>Product Of The Month</h1>
			{getDeals ? getDeals.map((item) =>
			{
				if (item.onSale)
				{
					flag += 1
					return <Deals key={flag} number={flag}  {...item}/>
				}
				return ''
			}) : ''}

		</>
	)
}

export default Home;